var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5L5 5.83333M5 5.83333L2.5 13.3333C3.9771 14.4445 6.02389 14.4445 7.50099 13.3334M5 5.83333L7.50005 13.3333M5 5.83333L10 4.16667M15 5.83333L17.5 5M15 5.83333L12.5 13.3333C13.9771 14.4445 16.0239 14.4445 17.501 13.3334M15 5.83333L17.5 13.3333M15 5.83333L10 4.16667M10 2.5V4.16667M10 17.5V4.16667M10 17.5H7.5M10 17.5H12.5",
    stroke: "#616161",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegal);
export default __webpack_public_path__ + "static/media/legal.98bf7f3823ed108bfc70043d1bb905e2.svg";
export { ForwardRef as ReactComponent };